var initializeFantasyFootballSkillSetBuilder = function (productId, labels) {
  
  TTG.UI.initializeModal("#addSkillsFromCustomSetDialog");
  TTG.UI.initializeModal("#addedToCartDialog");

  fantasyFootballSkillSetBuilder_UpdateLabels(labels);
  
  $("#set-language").on("change", () => 
  {
    fantasyFootballSkillSetBuilder_UpdateLabels(labels)
  });

  $("#addSkillsFromCustomSetButton").on("click", () => {
    TTG.UI.showModal("#addSkillsFromCustomSetDialog");
  });

  $("#addSkillsFromCustomSetDialog_addButton").on("click", () => {
    fantasyFootballSkillSetBuilder_addPredefinedSetById();
  });

  $("#addSkillsFromCustomSetDialog_closeButton").on("click", () => {
    TTG.UI.hideModal("#addSkillsFromCustomSetDialog");
  });
  
  $("#addedToCartDialog_continueButton").on("click", () => {
    TTG.UI.hideModal("#addedToCartDialog");
  });
  $("#addedToCartDialog_goToCartButton").on("click", () => {
    window.location.href = "/cart";
  });

  const clearAllButton = $("#clearAllButton").on("click", () =>
    fantasyFootballSkillSetBuilder_ClearAll(labels)
  );

  const skillSelects = $(".ffb-skill select");
  skillSelects.on("change", (e) => {
    fantasyFootballSkillSetBuilder_UpdateAddToCartButton(labels);
  });

  $('#addSkillSetbutton').on("click", () => 
  {
    fantasyFootballSkillSetBuilder_addPredefinedSet(labels);
  });

  const plusButtons = $(".ffb-skill-set-builder-section-plus-button");
  plusButtons.on("click", (e) => {
    const section = $(e.target).closest(".ffb-skill-set-builder-section");
    fantasyFootballSkillSetBuilder_PlusSection(
      section.attr("data-category-id"),
      labels
    );
  });

  const minusButtons = $(".ffb-skill-set-builder-section-minus-button");
  minusButtons.on("click", (e) => {
    const section = $(e.target).closest(".ffb-skill-set-builder-section");
    fantasyFootballSkillSetBuilder_MinusSection(
      section.attr("data-category-id"),
      labels
    );
  });

  const clearButtons = $(".ffb-skill-set-builder-section-clear-button");
  clearButtons.on("click", (e) => {
    const section = $(e.target).closest(".ffb-skill-set-builder-section");
    fantasyFootballSkillSetBuilder_ClearSection(
      section.attr("data-category-id"),
      labels
    );
  });

  const addToCartButton = $("#addToCartButton");
  addToCartButton.on("click", () => {
    fantasyFootballSkillSetBuilder_addToCart(productId, labels);
  });
  fantasyFootballSkillSetBuilder_UpdateAddToCartButton(labels);
  fantasyFootballSkillSetBuilder_UpdateSelectClasses();
};

var fantasyFootballSkillSetBuilder_UpdateLabels = function (labels) {
  const languageId = $("#set-language").val();
  const skillDivList = $('[data-skill-id]:not([data-skill-id=""])');
  for(let i = 0; i < skillDivList.length; i++)
  {
    const skillDiv = $(skillDivList.get(i));
    const skillId = skillDiv.attr('data-skill-id');
    skillDiv.find('.ffb-skill-name').text(TTG.FantasyFootball.Strings[languageId].skills[skillId]);
  }
}

var fantasyFootballSkillSetBuilder_PlusSection = function (sectionId, labels) {
  const section = $(
    ".ffb-skill-set-builder-section[data-category-id=" + sectionId + "]"
  );
  const selects = section.find("select");
  selects.each(function (index, element) {
    const select = $(element);
    var count = Number(select.val());
    count++;
    if (count > 20) count = 20;
    select.val(String(count));
  });
  fantasyFootballSkillSetBuilder_UpdateAddToCartButton(labels);
  fantasyFootballSkillSetBuilder_UpdateSelectClasses();
};

var fantasyFootballSkillSetBuilder_MinusSection = function (sectionId, labels) {
  const section = $(
    ".ffb-skill-set-builder-section[data-category-id=" + sectionId + "]"
  );
  const selects = section.find("select");
  selects.each(function (index, element) {
    const select = $(element);
    var count = Number(select.val());
    count--;
    if (count < 0) count = 0;
    select.val(String(count));
  });
  fantasyFootballSkillSetBuilder_UpdateAddToCartButton(labels);
};

var fantasyFootballSkillSetBuilder_ClearAll = function (labels) {
  const selects = $(".ffb-skill select");
  selects.val("0");
  fantasyFootballSkillSetBuilder_UpdateAddToCartButton(labels);
};

var fantasyFootballSkillSetBuilder_ClearSection = function (sectionId, labels) {
  const section = $(
    ".ffb-skill-set-builder-section[data-category-id=" + sectionId + "]"
  );
  const selects = section.find("select");
  selects.val("0");
  fantasyFootballSkillSetBuilder_UpdateAddToCartButton(labels);
};

var fantasyFootballSkillSetBuilder_UpdateSelectClasses = function () {
  const selects = $(".ffb-skill select");
  selects.each(function (index, element) {
    const select = $(element);
    const value = Number(select.val());
    if (value > 0) {
      select.addClass("has-value");
    } else {
      select.removeClass("has-value");
    }
  });
};

var fantasyFootballSkillSetBuilder_UpdateAddToCartButton = function (labels) {
  const skillDivs = $(".ffb-skill");
  var total = 0;
  skillDivs.each((i, e) => {
    const skillDiv = $(e);
    const skill_id = skillDiv.attr("data-skill-id");
    const skill_select = $("#fantasy-football-skill-" + skill_id);
    total = total + Number(skill_select.val());
  });
  const addToCartButton = $("#addToCartButton");
  if (total == 0) {
    addToCartButton.html(labels.addZeroSkillToCartButton);
    addToCartButton.attr("disabled", "disabled");
  } else if (total == 1) {
    addToCartButton.removeAttr("disabled");
    addToCartButton.html(labels.addOneSkillToCartButton);
  } else {
    addToCartButton.removeAttr("disabled");
    addToCartButton.html(
      TTG.formatStringWithObject(labels.addMoreThanOneSkillToCartButton, {
        skill_count: total,
      })
    );
  }
  fantasyFootballSkillSetBuilder_UpdateSelectClasses();
};

var fantasyFootballSkillSetBuilder_addSkill = function (
  currentSkill,
  newSkill
) {
  if (currentSkill === "") {
    return newSkill;
  } else {
    return currentSkill + ", " + newSkill;
  }
};

var fantasyFootballSkillSetBuilder_addPredefinedSetById = function(){   
  TTG.UI.hideModal("#addSkillsFromCustomSetDialog");
}

var fantasyFootballSkillSetBuilder_addPredefinedSet = function(){   
 TTG.UI.showModal("#addSkillsFromCustomSetDialog");
}

var fantasyFootballSkillSetBuilder_addToCart = function (productId, labels) {
 
  const languageId = $("#set-language").val();
  const skillDivs = $(".ffb-skill");
  var total = 0;

  var general_skills = "";
  var agility_skills = "";
  var mutations_skills = "";
  var strength_skills = "";
  var devious_skills = "";
  var passing_skills = "";
  var traits = "";
  var characteristics = "";
  const addToCartButton = $("#addToCartButton");
  var general_skill_count = 0;
  var agility_skill_count = 0;
  var mutations_skill_count = 0;
  var strength_skill_count = 0;
  var devious_skill_count = 0;
  var passing_skill_count = 0;
  var traits_skill_count = 0;
  var characteristics_skill_count = 0;

  skillDivs.each((i, e) => {
    const skillDiv = $(e);
    const category_id = skillDiv.attr("data-category-id");
    const skill_id = skillDiv.attr("data-skill-id");
    const skill_select = $("#fantasy-football-skill-" + skill_id);
    const count = Number(skill_select.val());
    total = total + count;
    if (count > 0) {
      const name = TTG.FantasyFootball.Strings[languageId].skills[skill_id];
      if (category_id === "general") {
        general_skill_count += count;
        general_skills = fantasyFootballSkillSetBuilder_addSkill(
          general_skills,
          name + " x " + String(count)
        );
      }
      if (category_id === "devious") {
        devious_skill_count += count;
        devious_skills = fantasyFootballSkillSetBuilder_addSkill(
          devious_skills,
          name + " x " + String(count)
        );
      }
      if (category_id === "agility") {
        agility_skill_count += count;
        agility_skills = fantasyFootballSkillSetBuilder_addSkill(
          agility_skills,
          name + " x " + String(count)
        );
      }
      if (category_id === "mutations") {
        mutations_skill_count += count;
        mutations_skills = fantasyFootballSkillSetBuilder_addSkill(
          mutations_skills,
          name + " x " + String(count)
        );
      }
      if (category_id === "strength") {
        strength_skill_count += count;
        strength_skills = fantasyFootballSkillSetBuilder_addSkill(
          strength_skills,
          name + " x " + String(count)
        );
      }
      if (category_id === "passing") {
        passing_skill_count += count;
        passing_skills = fantasyFootballSkillSetBuilder_addSkill(
          passing_skills,
          name + " x " + String(count)
        );
      }
      if (category_id === "traits") {
        traits_skill_count += count;
        traits = fantasyFootballSkillSetBuilder_addSkill(
          traits,
          name + " x " + String(count)
        );
      }
      if (category_id === "characteristics") {
        characteristics_skill_count += count;
        characteristics = fantasyFootballSkillSetBuilder_addSkill(
          characteristics,
          name + " x " + String(count)
        );
      }
    }
  });
  if (total > 0) {
    const properties = {};

    properties[labels.property_language] = languageId;

    properties["_fixed_quantity"] = total;
    properties["_type"] = "FFSkillHookSet",
    properties["_unique_id"] = TTG.Strings.generateRandomString();
    if (general_skills !== "") properties["General" + " (" + general_skill_count + ")"] = general_skills;
    if (agility_skills !== "") properties["Agility" + " (" + agility_skill_count + ")"] = agility_skills;
    if (devious_skills !== "") properties["Devious" + " (" + devious_skill_count + ")"] = devious_skills;
    if (mutations_skills !== "") properties["Mutations" + " (" + mutations_skill_count + ")"] = mutations_skills;
    if (strength_skills !== "") properties["Strength" + " (" + strength_skill_count + ")"] = strength_skills;
    if (passing_skills !== "") properties["Passing" + " (" + passing_skill_count + ")"] = passing_skills;
    if (traits !== "") properties[labels.property_traits + " (" + traits_skill_count + ")"] = traits;
    if (characteristics !== "") properties[labels.property_characteristics + " (" + characteristics_skill_count + ")"] = characteristics;

    let formData = {
      items: [
        {          
          id: Number(productId),
          quantity: total,
          properties: properties,
        },
      ],
    };

    addToCartButton.attr("disabled", "disabled");
    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        if (!response.ok) throw new Error("Network response was not ok");
        return response.json();
      })
      .then((data) => {
        const title = $("#addedToCartDialog .modal-dialog-title");
        var text = title.attr("data-text-one");
        if (total > 1) {
          text = TTG.formatStringWithObject(title.attr("data-text-more-than-one"), {
            skill_count: String(total),
          });
        }
        title.text(text);
        TTG.UI.showModal("#addedToCartDialog");
        addToCartButton.removeAttr("disabled");
      })
      .catch((error) => {
        console.error("There was an error adding the item to the cart:", error);
      });
  }
};
